import database from '../Database/database';

export const ADD_NOTE_LOCAL = 'ADD_NOTE_LOCAL'
export const ADD_NOTE_LOCAL_CREATE = 'ADD_NOTE_LOCAL_CREATE'
export const ADD_NOTE_LOCAL_CREATED = 'ADD_NOTE_LOCAL_CREATED'

export const ADD_NOTE_REQUESTED = 'ADD_NOTE_REQUESTED'
export const ADD_NOTE_FULFILLED = 'ADD_NOTE_FULFILLED'
export const ADD_NOTE_REJECTED = 'ADD_NOTE_REJECTED'

export const GET_NOTE_REQUESTED = 'GET_NOTE_REQUESTED'
export const GET_NOTE_FULFILLED = 'GET_NOTE_FULFILLED'
export const GET_NOTE_REJECTED = 'GET_NOTE_REJECTED'


export function addNote(note) {
  return { type: ADD_NOTE_LOCAL, note }
}

export function createNote(status) {
  switch (status) {
    case 'CREATE':
      return { type: ADD_NOTE_LOCAL_CREATE }
    default:
      return { type: ADD_NOTE_LOCAL_CREATED}
  }
}

export function getNotes() {
  return dispatch => {
    dispatch(getNotesRequestedAction());
    return database.ref('/notes').once('value', snap => {
      const notes = snap.val();
      dispatch(getNotesFulfilledAction(notes))
    })
    .catch((error) => {
      console.log(error);
      dispatch(getNotesRejectedAction());
    });
  }
}

function getNotesRequestedAction() {
  return {
    type: GET_NOTE_REQUESTED
  };
}

function getNotesRejectedAction() {
  return {
    type: GET_NOTE_REJECTED
  }
}

function getNotesFulfilledAction(notes) {
  return {
    type: GET_NOTE_FULFILLED,
    notes
  };
}

export function addToNotes(notes) {
  return dispatch => {
    dispatch(addNoteRequestedAction());
    const notesRef = database.ref('/notes');
    notes.map((note, i) => {
      note = {
          ...note,
          sync: true
      }
      notesRef.push(note)
      .then(() => {
        dispatch(addNoteFulfilledAction(note));
      })
      .catch((error) => {
        dispatch(addNoteRejectedAction());
      });
    })
  }
}

const addNoteRequestedAction = () => {
  return {
    type: ADD_NOTE_REQUESTED
  };
}

const addNoteRejectedAction = () => {
  return {
    type: ADD_NOTE_REJECTED
  }
}

const addNoteFulfilledAction = (note) => {
  return {
    type: ADD_NOTE_FULFILLED,
    note
  };
}



// WEBPACK FOOTER //
// ./src/Actions/actions.js